import en from 'dayjs/locale/en'

const locale: ILocale = {
  ...en,
  name: 'en',
  weekdays: 'monday_tuesday_wednesday_thursday_friday_saturday_sunday'.split('_'),
  weekStart: 0,
  weekdaysShort: 'Mon_Tue_Wed_Thu_Fri_Sat_Sun'.split('_'),
  monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
  weekdaysMin: 'Mo_Tu_We_Th_Fr_Sa_Su'.split('_'),
  ordinal: (n) => n
}

export default locale
